<script lang="ts">
	import { setContext } from 'svelte';
	import { MARKDOWN_CONTEXT } from '../../constants/contexts';

	interface Props {
		domain: string;
		children?: import('svelte').Snippet;
	}

	let { domain, children }: Props = $props();

	// `domain` is a configuration prop set once at mount; the context is established once for the component's lifetime.

	// svelte-ignore state_referenced_locally
	setContext(MARKDOWN_CONTEXT, { domain });
</script>

{@render children?.()}
